<app-user-dashboard [userMenuActiveItemIndex]="0" [activeItem]="'corporative'">
  <div class="card">
    <p-breadcrumb
      *ngIf="fridgestorageId == 0"
      class="breadcrumb-style max-w-full"
      [model]="breadcrumbMenuItems2"
      [home]="breadcrumbHome"></p-breadcrumb>
    <p-breadcrumb
      *ngIf="fridgestorageId > 0"
      class="breadcrumb-style max-w-full"
      [model]="breadcrumbMenuItems2Edit"
      [home]="breadcrumbHome"></p-breadcrumb>

    <div class="body-card py-3 px-4">
      <div class="header-card pt-0 mb-4">
        <div class="w-12 container-title">
          <h1 class="text-xl font-medium text-800 m-0">
            {{ fridgestorageId == 0 ?
              ('UserPages.UserFridgestorages.FridgestorageForm.CreateTitle' | translate) :
              ('UserPages.UserFridgestorages.FridgestorageForm.EditTitle' | translate)
            }}
          </h1>
        </div>
      </div>

      <div>
        <form [formGroup]="formGroup">
          <div class="p-fluid formgrid grid">
            <div class="field col-12 sm:col-6 md:col-4 lg:col-3">
              <label for="name">{{'UserPages.UserFridgestorages.FridgestorageForm.NameFieldLabel' | translate}} *</label>
              <input
                maxlength="{{formLimit.nameLimit}}"
                formControlName="name"
                type="text"
                pInputText
                required autofocus
                placeholder="{{'UserPages.UserFridgestorages.FridgestorageForm.NameFieldPlaceholder' | translate}}"
                class="custom-input"/>
              <small *ngIf="submit && formGroup.controls['name'].invalid" class="p-error">{{getErrorMessage('name')}}</small>
            </div>

            <div class="field col-12 sm:col-6 md:col-4 lg:col-3">
              <label for="storageType">{{'UserPages.UserFridgestorages.FridgestorageForm.StorageTypeLabel' | translate}}</label>
              <p-dropdown
                id="storageType"
                formControlName="storageType"
                [options]="storageTypes"
                optionLabel="label"
                optionValue="value"
                [showClear]="true"
                placeholder="{{'UserPages.UserFridgestorages.FridgestorageForm.StorageTypeLabel' | translate}}"
                class="custom-dropdown"
                dropdownIcon=""></p-dropdown>
            </div>

            <div class="field col-12 sm:col-6 md:col-4 lg:col-3">
              <label for="csp">{{'UserPages.UserFridgestorages.FridgestorageForm.CspFieldLabel' | translate}} *</label>
              <input
                id="csp"
                pInputText
                formControlName="csp"
                placeholder="{{'UserPages.UserFridgestorages.FridgestorageForm.CspFieldPlaceholder' | translate}}"
                class="custom-input"/>
              <small *ngIf="submit && formGroup.controls['csp'].invalid" class="p-error">{{getErrorMessage('csp')}}</small>
            </div>

            <div class="field col-12 sm:col-6 md:col-4 lg:col-3">
              <label for="vat">{{'UserPages.UserFridgestorages.FridgestorageForm.NitRutRucFieldLabel' | translate}} *</label>
              <input
                id="vat"
                pInputText
                formControlName="vat"
                placeholder="{{'UserPages.UserFridgestorages.FridgestorageForm.NitRutRucFieldPlaceholder' | translate}}"
                class="custom-input"/>
              <small *ngIf="submit && formGroup.controls['vat'].invalid" class="p-error">{{getErrorMessage('vat')}}</small>
            </div>

            <div class="field col-12 sm:col-6 md:col-4 lg:col-3">
              <label for="FDA">{{'UserPages.UserFridgestorages.FridgestorageForm.FDAFieldLabel' | translate}}</label>
              <input
                id="FDA"
                pInputText
                formControlName="FDA"
                placeholder="{{'UserPages.UserFridgestorages.FridgestorageForm.FDAFieldPlaceholder' | translate}}"
                class="custom-input"/>
              <small *ngIf="submit && formGroup.controls['FDA'].invalid" class="p-error">{{getErrorMessage('FDA')}}</small>
            </div>

            <div class="field col-12 sm:col-6 md:col-4 lg:col-3">
              <label for="contactName">{{'UserPages.UserFridgestorages.FridgestorageForm.ContactNameFieldLabel' | translate}} *</label>
              <input
                maxlength="{{formLimit.nameLimit}}"
                id="contactName"
                formControlName="contactName"
                type="text" pInputText required
                placeholder="{{'UserPages.UserFridgestorages.FridgestorageForm.ContactNameFieldPlaceholder' | translate}}"
                class="custom-input"/>
              <small *ngIf="submit && formGroup.controls['contactName'].invalid" class="p-error">{{getErrorMessage('contactName')}}</small>
            </div>

            <div class="field col-12 sm:col-6 md:col-4 lg:col-3">
              <label for="contactAddress">{{'UserPages.UserFridgestorages.FridgestorageForm.PlantAddressFieldLabel' | translate}} *</label>
              <input
                id="contactAddress"
                formControlName="contactAddress"
                type="text"
                pInputText required
                placeholder="{{'UserPages.UserFridgestorages.FridgestorageForm.PlantAddressFieldPlaceholder' | translate}}"
                class="custom-input"/>
              <small *ngIf="submit && formGroup.controls['contactAddress'].invalid" class="p-error">{{getErrorMessage('contactAddress')}}</small>
            </div>

            <div class="field col-12 sm:col-6 md:col-4 lg:col-3">
              <label for="city">{{'UserPages.UserFridgestorages.FridgestorageForm.CityFieldLabel' | translate}} *</label>
              <input
                id="city"
                maxlength="{{formLimit.cityLimit}}"
                formControlName="contactCity"
                type="text" pInputText required
                placeholder="{{'UserPages.UserFridgestorages.FridgestorageForm.CityFieldPlaceholder' | translate}}"
                class="custom-input"/>
              <small *ngIf="submit && formGroup.controls['contactCity'].invalid" class="p-error">{{getErrorMessage('contactCity')}}</small>
            </div>

            <div class="field col-12 sm:col-6 md:col-4 lg:col-3">
              <label for="contactEmail">{{'UserPages.UserFridgestorages.FridgestorageForm.ContactEmailFieldLabel' | translate}} *</label>
              <input
                id="contactEmail"
                maxlength="{{formLimit.mailLimit}}"
                formControlName="contactEmail"
                type="text"
                pInputText required
                placeholder="{{'UserPages.UserFridgestorages.FridgestorageForm.ContactEmailFieldPlaceholder' | translate}}"
                class="custom-input"/>
              <small *ngIf="submit && formGroup.controls['contactEmail'].invalid" class="p-error">{{getErrorMessage('contactEmail')}}</small>
            </div>

            <div class="field col-12 sm:col-6 md:col-4 lg:col-3">
              <label for="contactPhone">{{'UserPages.UserFridgestorages.FridgestorageForm.ContactPhoneFieldLabel' | translate}} *</label>
              <input
                id="contactPhone"
                maxlength="{{formLimit.phoneLimit}}"
                formControlName="contactPhone"
                type="text"
                pInputText placeholder="{{'UserPages.UserFridgestorages.FridgestorageForm.ContactPhoneFieldPlaceholder' | translate}}"
                class="custom-input"/>
              <small *ngIf="submit && formGroup.controls['contactPhone'].invalid" class="p-error">{{getErrorMessage('contactPhone')}}</small>
            </div>

            <div class="field col-12 sm:col-6 md:col-4 lg:col-3">
              <label for="fridgestorageCountry">{{'UserPages.UserFridgestorages.FridgestorageForm.CountryFieldLabel' | translate}} *</label>
              <p-dropdown
                id="fridgestorageCountry"
                [options]="countries"
                formControlName="contactCountry"
                optionLabel="name"
                [filter]="true"
                filterBy="name"
                [showClear]="true"
                placeholder="{{'UserPages.UserFridgestorages.FridgestorageForm.CountryFieldPlaceholder' | translate}}"
                (onChange)="onChangeCountry()"
                class="custom-dropdown">
                  <ng-template pTemplate="selectedItem">
                    <div class="flex align-items-center gap-2" *ngIf="selectedCountry">
                      <img [flag]="selectedCountry.code" style="width: 18px" alt=""/>
                      <span>{{ selectedCountry | countryDescription }}</span>
                    </div>
                  </ng-template>
                  <ng-template let-country pTemplate="item">
                    <div class="flex align-items-center gap-2">
                      <img [flag]="country" style="width: 18px" alt=""/>
                      <div>{{ country | countryDescription }}</div>
                    </div>
                  </ng-template>
              </p-dropdown>
              <small *ngIf="submit && formGroup.controls['contactCountry'].invalid" class="p-error">{{getErrorMessage('contactCountry')}}</small>
            </div>

            <div class="field col-12 sm:col-12 md:col-8 lg:col-6">
              <label for="observations">{{'UserPages.UserFridgestorages.FridgestorageForm.ObservationsFieldLabel' | translate}}</label>
              <textarea
                id="observations"
                formControlName="observations"
                class="custom-input custom-textarea"
                pInputTextarea
                rows="4"
                placeholder="{{'UserPages.UserFridgestorages.FridgestorageForm.ObservationsFieldPlaceholder' | translate}}"
              ></textarea>
            </div>

            <div class="col-12 pb-4">
              <div class="grid" style="margin-top: 30px;">
                <div class="col-12 md:col-6 lg:col-6"></div>
                <div class="col-12 md:col-6 lg:col-6">
                  <div class="grid p-fluid">
                    <div class="col-6">
                      <p-button
                        label="{{'UserPages.UserFridgestorages.FridgestorageForm.BackButton' | translate}}"
                        [disabled]="loading"
                        (onClick)="cancel()"
                        styleClass="p-button-outlined"
                        class="custom-text-button"/>
                    </div>
                    <div class="col-6">
                      <p-button
                        label="{{'UserPages.UserFridgestorages.FridgestorageForm.SaveButton' | translate}}"
                        [loading]="loading"
                        (onClick)="save()"
                        class="custom-text-button"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</app-user-dashboard>


